var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.71573 6.71573 0 15 0H22V15H0Z",
    fill: "#1A427D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20502 7.45092C5.92935 7.16974 5.48241 7.16974 5.20675 7.45092C4.93108 7.73211 4.93108 8.18792 5.20675 8.4691L9.44205 12.7891C9.71771 13.0703 10.1647 13.0703 10.4403 12.7891L20.7932 2.22912C21.0689 1.94794 21.0689 1.49206 20.7932 1.21088C20.5176 0.929706 20.0707 0.929706 19.795 1.21088L9.94118 11.2617L6.20502 7.45092Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicked);
export default __webpack_public_path__ + "static/media/ticked.c6fd62c5a80b7d04e8c5643d9419d3d4.svg";
export { ForwardRef as ReactComponent };